import { useState } from "react";
import useSWR from "swr";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";

import ImageCard from "../../components/ImageCard";
import { getTranslation } from "../../utils/translate";
import ListPage from "../../layouts/ListPage";
import { pageNumber, pageSize } from "../../utils/pagination";
import { languages } from "../../utils/translate";

const CollectionList = () => {
  const [page, setPage] = useState(pageNumber);
  const [language, setLanguage] = useState(languages[0]);

  const filter = {
    _and: [
      {
        type: {
          _neq: "CUISINE",
        },
      },
    ],
  };

  const payload = {
    fields: ["*", "translations.*"],
    filter,
    limit: pageSize,
  };

  let { data: pageData, isLoading: pageDataLoading } = useSWR({
    url: "collections?meta=*",
    ...payload,
  });

  const summaryValues = [
    {
      label: "Total",
      value: pageData?.meta?.filter_count || "-",
    },
  ];

  return (
    <ListPage
      title="Collections"
      summaries={summaryValues}
      searchStorageKey={"cuisine"}
      handleSearchComplete={() => {}}
      searchOnly={["COLLECTIONS"]}
      breadcrumbsLinks={[
        {
          url: "/collections-menu",
          content: "Collections & Cuisine",
        },
      ]}
      language={language}
      setLanguage={setLanguage}
      pageNumber={page}
      setPageNumber={setPage}
      numberOfPages={Math.ceil(pageData?.meta?.filter_count / pageSize)}
      loading={pageDataLoading}
    >
      <Box sx={{ flexGrow: 1, my: 3 }}>
        <Grid sx={{ mt: 4 }} container spacing={2}>
          {pageData?.data?.map((item) => (
            <Grid item key={item.id} xs={6} sm={4} md={4} lg={3} xl={2}>
              <ImageCard
                url={`/collections/${item.id}`}
                item={{
                  title: getTranslation(item, {
                    key: "languages_code",
                    code: language.code,
                  }).title,
                  description: getTranslation(item, {
                    key: "languages_code",
                    code: language.code,
                  }).content,
                  url: getTranslation(item, {
                    key: "languages_code",
                    code: language.code,
                  })?.image
                    ? `${process.env.REACT_APP_API_URL}/assets/${
                        getTranslation(item, {
                          key: "languages_code",
                          code: language.code,
                        })?.image
                      }`
                    : "",
                }}
              />
            </Grid>
          ))}
        </Grid>
      </Box>
    </ListPage>
  );
};

export default CollectionList;
